import { types } from './constants';

export const loadWidget = (accessToken, contentID) => ({
  type: types.WIDGET_FETCH,
  accessToken,
  contentID,
});

export const loadWidgetError = (error) => ({
  type: types.WIDGET_FETCH_FAILURE,
  error,
});

export const loadWidgetSuccess = (content) => ({
  type: types.WIDGET_FETCH_SUCCESS,
  content,
});

export const selectContent = (content) => ({
  type: types.CONTENT_SELECTED,
  content,
});

export const clearStates = () => ({
  type: types.CLEAR_STATES,
});

export const startNextEpisode = (status, router, contentid, pathPlayer) => ({
  type: types.START_NEXT_EPISODE,
  status,
  router,
  contentid,
  pathPlayer,
});

export const startNextEpisodeSuccess = (status) => ({
  type: types.START_NEXT_EPISODE_SUCCESS,
  status,
});

export const startNextEpisodeError = (error) => ({
  type: types.START_NEXT_EPISODE_FAILURE,
  error,
});

export const clearIsNextEpisodePlayer = () => ({
  type: types.CLEAR_IS_NEXT_EPISODE_PLAYER,
});

export const loadZappingList = (accessToken, zappingOrigin) => ({
  type: types.ZAPPING_LIST_FETCH,
  accessToken,
  zappingOrigin,
});

/**
 * Requests the remaining episodes of an episode's series season, to build
 * the zapping list for an EPISODE content.
 *
 * @param {Object} accessToken
 * @param {string} serieId id of the series the episode belongs to
 * @param {number} season episode's season
 */
export const loadZappingEpisodes = (accessToken, serieId, season) => ({
  type: types.ZAPPING_EPISODES_FETCH,
  accessToken,
  serieId,
  season,
});

/**
 * Caches a season's episodes (series+season) for zapping, so they're not
 * requested again when re-entering the player.
 *
 * @param {string} key `${serieId}:${season}`
 * @param {Array<Object>} contents season's episodes
 */
export const loadZappingEpisodesSuccess = (key, contents) => ({
  type: types.ZAPPING_EPISODES_FETCH_SUCCESS,
  key,
  contents,
});

export const loadZappingEpisodesError = (error) => ({
  type: types.ZAPPING_EPISODES_FETCH_FAILURE,
  error,
});

export const loadZappingListSuccess = (contents) => ({
  type: types.ZAPPING_LIST_FETCH_SUCCESS,
  contents,
});

export const loadZappingListError = (error) => ({
  type: types.ZAPPING_LIST_FETCH_FAILURE,
  error,
});

/**
 * Stores the items the content list already had loaded at the time of the
 * click.
 *
 * The player uses them to build the zapping list without requesting it
 * again; it only calls the service if nothing arrived or the list was left
 * incomplete (the carousel only requests the items it shows).
 *
 * @param {string} widgetId component the content came from
 * @param {Array<Object>} contents already-loaded items
 * @param {boolean} isComplete true if the component already has the entire list
 */
export const setZappingSource = (widgetId, contents, isComplete) => ({
  type: types.ZAPPING_SOURCE_SET,
  widgetId,
  contents,
  isComplete,
});
